import { css } from 'styled-components';
import { getToken } from './utils';

export const FOCUS_OUTLINE = css`
    &:focus {
        outline: auto;
    }
    &:focus-visible {
        outline: auto;
    }
    &:focus:not(:focus-visible) {
        outline: 0;
    }
`;

export const FOCUS_OUTLINE_STYLE = css`
    outline: ${getToken('borderWidth200')}px solid ${getToken('borderInteractiveFocus')};
    outline-offset: ${getToken('borderWidth200')}px;
`;

export const VISUALLY_HIDDEN = css`
    border: 0;
    clip: rect(0 0 0 0);
    height: 0;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 0;
`;

export const ELLIPSIS = `
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
